import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const fetchCarteraClienteAdmin = (query) => http.get(`${api}/operacion/cartera-proveedor-admin`, { params: { ...query } })

export {
  fetchCarteraClienteAdmin
}
